import styled from 'styled-components'

import { mq, sizes } from '../../../theme'

export const BlockUrpsFacts = styled.div``

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
  margin: 0;

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.firaSans4XlBold};
  }
`

export const FactList = styled.ul`
  list-style: none;
  margin-top: 6rem;
  padding: 0;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    justify-content: center;
    gap: 6rem;
  }
`

export const FactListItem = styled.li`
  max-width: 30.5rem;
  width: 100%;
  text-align: center;
`
